import { lazy } from 'react';

export const AdMediumMapping = {
  Products: lazy(() => import('./containers/Products/index.tsx')),
  Mappings: lazy(() => import('./containers/Mappings/index.tsx')),
};
